module.exports = "varying vec2 v_uv;\r\n\r\nvoid main()\t{\r\n    v_uv = uv;\r\n    gl_Position = vec4(position, 1.0);\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/fractal_vp.glsl
// module id = 8
// module chunks = 0